// ServiceTitan's text shown as text (history fix 4, 22 Oct): a job's summary showed Word's markup
// ("<o:p></o:p>") as it came. The load makes ServiceTitan's text plain (stText); this is the screen's
// guard for any that still carries a tag. A tag goes (a break, a paragraph's or a block's edge is a
// space); text with none comes back exactly as it was, so "under 50 psi, <5 min" is left alone.

const TAG = /<\/?([a-zA-Z][a-zA-Z0-9:-]*)(?:\s[^<>]*)?\/?>/g;
const BREAK = /^(br|p|div|li|tr|td|h[1-6])$/i;

/** The text with any HTML tag taken out; unchanged when it has none. */
export function plainText(s: string): string;
export function plainText(s: string | null): string | null;
export function plainText(s: string | null): string | null {
  if (!s || !/<\/?[a-zA-Z]/.test(s)) return s;
  const out = s.replace(TAG, (_tag, name: string) => (BREAK.test(name) ? ' ' : ''));
  return out === s ? s : out.replace(/[ \t]{2,}/g, ' ').trim();
}
